import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavDropdown } from 'react-bootstrap';
import { Globe } from 'react-bootstrap-icons';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
];

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation('navigation');

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  return (
    <NavDropdown
      title={<span><Globe className="mr-1" /> {currentLanguage.flag}</span>}
      id="language-menu"
      align="end"
    >
      {languages.map((lang) => (
        <NavDropdown.Item
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          active={i18n.language === lang.code}
        >
          {lang.flag} {lang.name}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
}

export default LanguageSwitcher;
